import { withDefaults } from '@warp-drive/legacy/model/migration-support';

// API resource: tio-api app/resources/api/v1/plan_audit_schedule_resource.rb
// One plan-audit-schedule per plan (plan_id UNIQUE constraint). The schedule
// holds the cadence and, for bi_annually/quarterly, the audit_month (1–12).
// For custom cadence, audit_month is null and the periods drive the schedule.
const PlanAuditScheduleSchema = withDefaults({
  type: 'plan-audit-schedule',
  fields: [
    { kind: 'attribute', name: 'cadence' },
    { kind: 'attribute', name: 'auditMonth' },
    {
      kind: 'belongsTo',
      name: 'plan',
      type: 'plan',
      options: { async: false, inverse: 'planAuditSchedule' },
    },
    {
      kind: 'hasMany',
      name: 'planAuditPeriods',
      type: 'plan-audit-period',
      options: { async: false, inverse: 'planAuditSchedule' },
    },
  ],
});

export default PlanAuditScheduleSchema;
